import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminUsageEQueriesReportFilterItems } from './admin-usage-e-queries-report-filter-items';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdminUsageEQueriesReport } from './model/admin-usage-e-queries-report';
import { AdminUsageEQueriesReportFilter } from './model/admin-usage-e-queries-report-filter';
import { filter, switchMap } from 'rxjs/operators';

@Component({
    selector: 'admin-usage-e-queries-report',
    template: require('./admin-usage-e-query-report.component.html'),
    styles: [require('./admin-usage-e-query-report.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminUsageEQueryReportComponent {
    public readonly adminUsageEQueriesReport$: Observable<AdminUsageEQueriesReport>;
    private filter$ = new BehaviorSubject<AdminUsageEQueriesReportFilter>(undefined);
    constructor(private adminUsageEQueriesReportFilterItems: AdminUsageEQueriesReportFilterItems) {
        this.adminUsageEQueriesReport$ = this.filter$.pipe(
            filter(v => !!v),
            switchMap((reportFilter) => {
                return this.adminUsageEQueriesReportFilterItems.getUsageEQueriesReport(reportFilter);
            })
        );
    }

    public onSearch(reportFilter: AdminUsageEQueriesReportFilter) {
        this.filter$.next(reportFilter);
    }
}
